import React from 'react';
import { Link } from 'react-router-dom';
import { useTheme } from '../contexts/ThemeContext';
import { useTranslation } from 'react-i18next';

function Footer() {
  const { darkMode } = useTheme();
  const currentYear = new Date().getFullYear();
  const { t } = useTranslation();

  return (
    <footer className={`mt-auto py-6 ${darkMode ? 'bg-gray-900 text-gray-300' : 'bg-gray-100 text-gray-700'}`}>
      <div className="max-w-7xl mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* About section */}
          <div>
            <h3 className="text-lg font-semibold mb-3">{t('footer.about')}</h3>
            <p className="text-sm">
              {t('footer.aboutText')}
            </p>
          </div>
          
          {/* Quick links */}
          <div>
            <h3 className="text-lg font-semibold mb-3">{t('footer.quickLinks')}</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/discovery" className="footer-link">
                  {t('navbar.discovery')}
                </Link>
              </li>
              <li>
                <Link to="/content2learn" className="footer-link">
                  Content2Learn
                </Link>
              </li>
            </ul>
          </div>
          
          {/* Contact */}
          <div>
            <h3 className="text-lg font-semibold mb-3">{t('footer.contact')}</h3>
            <p className="text-sm mb-2">
              {t('footer.contactText')}
            </p>
            <a 
              href="mailto:contact@content2learn.com" 
              className="footer-link font-medium"
            >
              {t('footer.email')}
            </a>
          </div>
        </div>
        
        {/* Copyright */}
        <div className="mt-8 pt-4 border-t border-gray-200 dark:border-gray-700 text-center text-sm">
          <p>&copy; {currentYear} Content2Learn. {t('footer.copyright')}</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
